import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { errMsg } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { LogoMark } from "@/components/site/Logo";

const field = "w-full rounded-2xl border border-fg/10 bg-[var(--ink)] px-5 py-4 text-fg outline-none placeholder:text-mist focus:border-[var(--volt)]/60";

export const AdminLogin = ({ denied }) => {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const data = await login(email, password);
      if (data?.role !== "admin") setError("Questo account non ha accesso al pannello.");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="flex min-h-screen items-center justify-center px-5">
      <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-sm rounded-[2rem] border border-fg/10 bg-[var(--ink-2)] p-8">
        <Link to="/" data-testid="admin-login-home-link"><LogoMark className="h-12 w-12" /></Link>
        <h1 className="mt-6 font-display text-3xl">Area riservata</h1>
        <p className="mt-1 text-sm text-mist">Accesso solo per lo staff PhoneSmartX.</p>
        {denied && !error && <p className="mt-3 text-sm text-[var(--flare)]" data-testid="admin-denied">Sei connesso con un account cliente. Accedi con l'account admin.</p>}
        <div className="mt-6 space-y-3">
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" data-testid="admin-login-email-input" className={field} />
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" data-testid="admin-login-password-input" className={field} />
        </div>
        {error && <p className="mt-3 text-sm text-[var(--flare)]" data-testid="admin-login-error">{error}</p>}
        <button disabled={busy} data-testid="admin-login-submit-button" className="mt-6 flex w-full items-center justify-center gap-2 rounded-full bg-[var(--volt)] py-4 font-semibold text-[var(--ink)] disabled:opacity-60">
          {busy && <Loader2 className="h-5 w-5 animate-spin" />} Accedi
        </button>
      </form>
    </main>
  );
};
